import $ from 'jquery';
import 'signalr';

/**
 * 基于 SignalR 的车辆 GPS 位置推送客户端
 * 替代原生 WebSocket，连接到服务端 GPSHub
 *
 * @param {string} signalrUrl - SignalR 服务端地址（开发环境：/signalr，生产环境：https://class.busboss.cn/signalr）
 * @param {string} vehicleGidList - 车辆GID列表（逗号分隔）
 * @param {function} callback - 接收 GPS 数据的回调函数
 * @param {object} [options] - 可选配置
 * @param {object} [options.qs] - 额外的查询字符串参数（如 { _Authorization: token }）
 * @param {function} [options.onOpen] - 连接成功回调
 * @param {function} [options.onError] - 连接失败回调
 * @param {function} [options.onClose] - 连接关闭回调
 */
export class VehicleWebSocket {
    constructor(signalrUrl, vehicleGidList, callback, options) {
        this.callback = callback;
        options = options || {};

        // 创建 SignalR Hub 连接（代理方式）
        // useDefaultPath: false —— signalrUrl 已包含 /signalr 路径，不再自动追加
        const connection = $.hubConnection(signalrUrl, { useDefaultPath: false });
        const hubProxy = connection.createHubProxy('GPSHub');

        // 设置查询参数（替代原 WebSocket URL 中的参数）
        connection.qs = Object.assign({
            VehicleGIDList: vehicleGidList
        }, options.qs || {});

        // 定义客户端接收数据的方法（服务端通过 receiveGpsData 推送）
        hubProxy.on('receiveGpsData', (data) => {
            this.callback(data);
        });

        // 启动连接
        connection.start()
            .done(() => {
                console.log(`SignalR连接已建立，vehicleGidList: ${vehicleGidList}`);
                if (options.onOpen) options.onOpen();
            })
            .fail((error) => {
                console.error('SignalR连接失败:', error);
                if (options.onError) options.onError(error);
            });

        // 连接关闭事件
        connection.disconnected(() => {
            console.log('SignalR连接已关闭');
            if (options.onClose) options.onClose();
        });

        this.connection = connection;
        this.hubProxy = hubProxy;
    }

    close() {
        if (this.connection) {
            this.connection.stop();
        }
    }
}
